import { SVGProps } from 'react';

const PersonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" {...props}>
    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
  </svg>
);
export default PersonIcon;
